/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Tokens } from '@jda/lui-common-component-library-mui5';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    flexGrow: 1,
  },
  loader: {
    position: "absolute",
    top: "45%",
    zIndex: 1,
    left: "50%",
    alignItems: "center",
    padding: Tokens.spacing['$sp-3']
  },
  addUserButton: {
    marginRight: `${Tokens.spacing['$sp-2']} !important`
  },
  assignRoleButton: {
    marginRight: `${Tokens.spacing['$sp-0-5']} !important`
  },
  searchBarWrap: {
    width: Tokens.spacing['$sp-80']
  },
  topRightHeaderContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: Tokens.spacing['$sp-2'],
    textAlign: 'right',
    height: Tokens.spacing['$sp-7-5'],
    color: theme.palette.text.secondary,
  },
  rightContainer: {
    textAlign: 'left',
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 0,
    overflowY: 'auto',
    borderBottomRightRadius: Tokens.spacing['$sp-1'],
    height: 'calc(100vh - 195px)',
    "&.MuiBox-root": {
      padding: Tokens.spacing['$sp-0']
    }
  },
  noClients: {
    marginTop: Tokens.spacing['$sp-3-5'],
    padding: Tokens.spacing['$sp-2']
  },
  displayNameHeading: {
    marginLeft: Tokens.spacing['$sp-8-5']
  },
  horizontalScroll: {
    overflowX: 'hidden'
  },
  deleteIcon: {
    marginLeft: 'auto'
  },
  rolesListContainer: {
    padding: theme.spacing(1, 0)
  },
  listContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  topLeftHeaderContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  searchField: {
    margin: `0 ${Tokens.spacing['$sp-4']}`,
    color: theme.palette.text.secondary,
    // borderBottomStyle: 'solid',
    // borderBottomWidth: Tokens.spacing['$sp-0-25'],
    // borderBottomColor: theme.palette.text.secondary
  },
  roleAssignmentModal: {
    display: 'flex',
    justifyContent: 'center',
  },
  conjuction: {
    color: theme.palette.text.secondary,
    textAlign: 'center'
  },
  searchKeyDD: {
    padding: Tokens.spacing['$sp-2'],
    '& #dropdown-select-user-search-key': {
      borderBottomColor: theme.palette.text.secondary
    }
  },
  buttonPanel: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  listSubheader: {
    paddingTop: 0,
    paddingBottom: 0,
    lineHeight: 1.5,
    color: theme.palette.text.primary,
  },
  listItem: {
    paddingLeft: '30px',
    paddingTop: 0,
    '&:not(:last-child)': {
      paddingBottom: 0,
    },
    '& svg': {
      marginRight: '5px'
    }
  },
  popover: {
    boxShadow: theme.shadows[5],
    '& .header': {
      paddingBottom: '5px!important',
    },
    color: theme.palette.text.primary,
    maxHeight: '600px',
    overflowY: 'scroll',
  },
  popoverMessage: {
    padding: '16px',
  },
  loaderPopover: {
    display: 'flex',
    justifyContent: 'center'
  },
  selectDropdown: {
    'input[type="text"]': {
      paddingInline: 0
    },
    '& .MuiInputBase-root::before': {
      height: 'auto'
    }
  },
  toolbarPanel: {
    padding: `${Tokens.spacing['$sp-3']} 0`,
  },
}));
